import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-step2',
  templateUrl: './step2.component.html',
  styleUrls: ['./step2.component.scss']
})
export class Step2Component implements OnInit {
  @Input() DtForm: FormGroup;
  @Input() formattedDate: string;
  @Output() dateEmitter = new EventEmitter<string>();
  minDate = new Date();

  constructor() { }

  ngOnInit() {
  }

  formatDate() {
    var pipe = new DatePipe("en-US");
    this.formattedDate = pipe.transform(this.DtForm.get("DateForm").get("date").value, "dd/MM/yyyy");
    this.dateEmitter.emit(this.formattedDate);
  }
}
